import { IList } from "./List";
import pdf from '../../assets/images/pdf.png'

interface IListDetailsProps {
  el: IList;
}

const ListDetails: React.FC<IListDetailsProps> = ({ el }) => {
  const files = el.file ?? [];
  const labels = el.label ?? [];

  return (
    <div className="list-details">
      <h2 className="list-header">{el.title}</h2>

      {el.description?.map((paragraph, index) => (
        <p key={index} className="list-description">
          {paragraph}
        </p>
      ))}

      {files.map((file, index) => (
        <a
          key={index}
          href={file}
          target="_blank"
          rel="noreferrer"
          download
          className="link-to-pdf"
        >
          <img src={pdf} alt="icon pdf" />
          <p>{labels[index] ?? 'Скачать'}</p>
        </a>
      ))}

      <p
        className="list-description"
        style={{ paddingTop: '1rem', color: 'whitesmoke' }}
      >
        Техническая поддержка и расчет стоимости осуществляется по заявкам на почту info@ommatid.com
      </p>
    </div>
  );
};

export default ListDetails;